//2024-09-30 蒸洗
import SteamCleanHome from '@/pages/Steam/steamCleanHome'

import SteamVehicleList from '@/pages/SteamVehicle/vehicleList'

import SteamSearchVehicle from '@/pages/SteamVehicle/steamSearchVehicle'

import addAllCar from "@/views/Vehicle/addAllCar.vue";

import SteamAddUserInfo from '@/pages/SteamUserInfo/addUserInfo'//新增用户信息
import SteamEditUserInfo from '@/pages/SteamUserInfo/editUserInfo'//编辑用户信息

import SteamUploadPound from '@/pages/SteamUpload/steamUploadPound'//上传磅单

import SteamAddAppointment from '@/pages/SteamAppointment/addAppointment'//新增预约
import SteamAppointmentList from '@/pages/SteamAppointment/steamAppointmentList'//预约列表
import SteamAppointmentInfo from '@/pages/SteamAppointment/steamAppointmentInfo'//预约列表

//蒸洗支付
//import SteamOrderPay from '@/pages/SteamOrder/orderPay'//新增充值
//import SteamOrderList from "@/pages/SteamOrder/orderList"//充值列表
//import SteamOrderInfo from "@/pages/SteamOrder/orderInfo"//充值详情

//蒸洗操作员
import SteamConfirmSignature from '@/pages/SteamOperation/confirmSignature'//司机确认签字

import SteamSearchChetou from '@/pages/Public/searchChetouIndex'
import SteamSearchChegua from '@/pages/Public/searchCheguaIndex'

import SteamAssignmentList from '@/pages/SteamAssignment/steamAssignmentList'//作业列表
import SteamAssignmentInfo from '@/pages/SteamAssignment/steamAssignmentInfo'//作业详情

import SteamxyIndex from '@/pages/Steam/steamxyIndex'

const router = [
  /*{
    path: "/steam-order-pay/:id",
    name: "steamOrderPay",
    component: SteamOrderPay,
    meta: {
      title: '蒸洗预支付'
    }
  },
  {
    path: "/steam-order-list",
    name: "steamOrderList",
    component: SteamOrderList,
    meta: {
      title: '蒸洗支付列表'
    }
  },
  {
    path: "/steam-order-info/:id",
    name: "steamOrderInfo",
    component: SteamOrderInfo,
    meta: {
      title: '蒸洗支付详情'
    }
  },
  */
  {
    path: "/steam-clean-home",
    name: "steamCleanHome",
    component: SteamCleanHome,
    meta: {
      title: '蒸洗预约'
    }
  },
  {
    path: "/Vehicle",
    name: "vehicle",
    component: SteamVehicleList,
    meta: {
      title: '车辆信息'
    }
  },
  {
    path: "/steam-add-userinfo",
    name: "steamAddUserInfo",
    component: SteamAddUserInfo,
    meta: {
      title: '新增用户信息'
    }
  },
  {
    path: "/steam-edit-userinfo/:id",
    name: "steamEditUserInfo",
    component: SteamEditUserInfo,
    meta: {
      title: '编辑用户信息'
    }
  },
  {
    path: "/steam-upload-pound",
    name: "steamUploadPound",
    component: SteamUploadPound,
    meta: {
      title: '上传磅单'
    }
  },
  {
    path: "/steam-add-appointment",
    name: "steamAddAppointment",
    component: SteamAddAppointment,
    meta: {
      title: '新增预约'
    }
  },
  {
    path: "/steam-comfirm-signature",
    name: "steamConfirmSignature",
    component: SteamConfirmSignature,
    meta: {
      title: '确认电子签字'
    }
  },
  {
    path: "/addnewVehicle",
    name: "addnew",
    component: SteamSearchVehicle,
    meta: {
      title: '绑定车辆'
    }
  },
  {
    path: "/addAllCar",
    name: "addAllCar",
    component: addAllCar,
    meta: {
      title: '新增车辆'
    }
  },
  {
    path: "/steam-search-chetou",
    name: "steamSearchChetou",
    component: SteamSearchChetou,
    meta: {
      title: '搜索车头号'
    }
  },
  {
    path: "/steam-search-chegua",
    name: "steamSearchChegua",
    component: SteamSearchChegua,
    meta: {
      title: '搜索车挂号'
    }
  },
  {
    path: "/steam-appointment-list",
    name: "steamAppointmentList",
    component: SteamAppointmentList,
    meta: {
      title: '预约列表',
      keepAlive: true
    }
  },
  {
    path: "/steam-appointment-info/:id",
    name: "steamAppointmentInfo",
    component: SteamAppointmentInfo,
    meta: {
      title: '预约详情'
    }
  },
  {
    path: "/steam-assignment-list",
    name: "steamAssignmentList",
    component: SteamAssignmentList,
    meta: {
      title: '作业列表',
      keepAlive: true
    }
  },
  {
    path: "/steam-assignment-info/:id",
    name: "steamAssignmentInfo",
    component: SteamAssignmentInfo,
    meta: {
      title: '作业详情'
    }
  },
  {
    path: "/steamxy",
    name: "steamxy",
    component: SteamxyIndex,
    meta: {
      title: '槽车蒸洗入库须知'
    }
  },

];

export default router
